import React from 'react';
import _ from 'lodash';
import { AppEventName, useAppEventSelectFieldQuery } from 'generated/graphql';


export interface IAppEvent {
  id: string;
  name: AppEventName;
  displayName: string;
}

export interface IData {
  objects: IAppEvent[];
}

export function useQuery({
  orderId, returnAuthorizationId
}: {
  orderId?: string;
  returnAuthorizationId?: string;
} = {}) {

  const queryTuple = useAppEventSelectFieldQuery({
    variables: {
      options: {
        filter: {
          orderId: orderId,
          returnAuthorizationId: returnAuthorizationId
        }
      }
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.appEvents ?? [], (node): IAppEvent => ({
        id: node.id,
        name: node.name,
        displayName: node.displayName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}

